module.exports = __webpack_public_path__ + "img/none.22c6439d.png";